import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-progress-bar',
  templateUrl: './split-progress-bar.component.html',
  styleUrls: ['./split-progress-bar.component.scss']
})
export class SplitProgressBarComponent {
  @Input() value : Array<number> = [];
  @Input() colors : Array<string> = [];
  @Input() bgColor = '#e6e9ee';

  get colorsLength() : number {
    return this.colors.length - 1;
  }
  border(index : number,value: number) {
    let borderStyle = '';
    let last : boolean = (index == this.colorsLength);
    
     /*ultimo*/
     if(last) {
      borderStyle = 'border-radius: 0 10px 10px 0';
    }

    /*primeiro e unico*/ 
    if(index == 0 && this.colorsLength == 0) {
      borderStyle = (value == 100 || value > 100) ? 'border-radius:10px' :'border-radius: 10px 0 0 10px;';
    } 
    /*primeiro & total cores > 1*/ 
    if(index == 0 && this.colorsLength > 0) {
      borderStyle = 'border-radius: 10px 0 0 10px;';
    } 
    /*do meio*/
    if(index != 0 && !last) {
      borderStyle = 'border-radius: 0px';
    } 
   
    return borderStyle;
  }

}
